export default __webpack_public_path__ + "static/1_1-744d4419ea6504b77fca4d6aea606c87.jpg";